import {Button, Table} from "antd";
import React, {useEffect, useState} from "react";
import {useAttendanceStepRepository} from "../../../../../domain/repository/attendance-step.repository";
import {AttendanceStepEntity} from "../../attendance/domain/entity/attendance-step.entity";
import {AttendanceStepDateAlertComponent} from "../../attendance/component/attendance-step-date-alert.component";

export function PendingStepsComponent(props: {
  currentUserSelected?: boolean,
  onStepClick: (step: AttendanceStepEntity) => any,
}) {
  const [pendingSteps, setPendingSteps] = useState<AttendanceStepEntity[]>([])
  const attendanceStepRepo = useAttendanceStepRepository();
  
  useEffect(() => {
    attendanceStepRepo.listPendingSteps(
      !props.currentUserSelected
    ).then(res => setPendingSteps(res.data))
  }, [props.currentUserSelected]);
  
  return (
    <Table
      columns={[
        {
          title: 'Tipo de Movimentação',
          dataIndex: 'stepType',
          render: item => item?.description,
        },
        {
          title: 'Cliente',
          dataIndex: 'clientName',
          
        },
        {
          title: 'Período',
          dataIndex: 'endDate',
          render: (endDate) => (
            <AttendanceStepDateAlertComponent showDate endDate={endDate} />
          )
        },
        {
          title: 'Código do Processo',
          dataIndex: 'processCode'
        },
        {
          title: 'Tipo do Processo',
          dataIndex: 'processTypeDescription',
          render: (item, row) => item ? `${item} -> ${row.processSubtypeDescription}` : ''
        },
        {
          title: '',
          dataIndex: 'id',
          render: (id, item) => <Button type={'link'} onClick={() => props.onStepClick(item)}>Detalhes</Button>
        }
      ]}
      dataSource={pendingSteps}
    />
  )
}